import { Container, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import SingleTestExecutionComponent from '../../components/project-dashboard/test-cases/single-test-case/SingleTestExecutionPage';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const SingleTestExecutionPage = () => {
  const { key: executionKey, projectId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const testCycleKey = queryParams.get('testcycle');
  const associatedTestCaseKey = queryParams.get('association');
  const navigate = useNavigate();

  useEffect(() => {
    if (!executionKey || !projectId || !testCycleKey || !associatedTestCaseKey) {
      navigate('/error');
    }
  }, []);

  return (
    <DashboardLayout>
      <Container maxWidth="xxl">
        <Grid container spacing={2}>
          <Grid item md={12}>
            <SingleTestExecutionComponent
              executionKey={executionKey}
              projectId={projectId}
              testCycleKey={testCycleKey}
              associatedTestCaseKey={associatedTestCaseKey}
            />
          </Grid>
        </Grid>
      </Container>
    </DashboardLayout>
  );
};

export default SingleTestExecutionPage;
